<template>
  <v-app id="app">
    <v-navigation-drawer
      v-model="drawer"
      app
      absolute
      temporary
      fixed
      class="primeweb"
    >
      <v-toolbar
        flat
        class="primeweb darken-3"
        @click="onSideIconClick"
      >
        <v-list>
          <v-list-tile>
            <v-list-tile-title class="title">
              <span class="text-text">{{ strings.options }}</span>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider />
      <v-list
        v-if="accounts.length > 1"
        dense
        class="pt-0 pb-0"
      >
        <v-list-group
          prepend-icon="mdi-account"
          value="true"
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>{{ strings.accounts }}</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile
            v-for="(account, index) in accountList"
            :key="index"
            @click="onNavigateToAccount(account.value)"
          >
            <v-list-tile-title v-text="account.name" />
          </v-list-tile>
        </v-list-group>
      </v-list>
      <v-list
        v-if="groups && groupList.length > 0"
        dense
        class="pt-0"
      >
        <v-list-group
          prepend-icon="mdi-view-dashboard"
          value="true"
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>{{ strings.groups }}</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile
            v-for="(group, index) in groupList"
            :key="index"
            @click="onNavigateToGroup(group.groupId)"
          >
            <v-list-tile-title v-text="group.name" />
            <v-list-tile-action>
              <v-icon
                color="text"
                v-text="selectNumberIcon(group.poiIds.length)"
              />
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
      </v-list>
      <v-list v-else>
        <v-list-group
          prepend-icon="mdi-view-dashboard"
          class="view"
          value="true"
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>{{ strings.groups }}</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile>
            <v-list-tile-title>{{ strings.noOutstandingPois }}</v-list-tile-title>
          </v-list-tile>
        </v-list-group>
      </v-list>
      <v-list
        dense
        class="pt-0"
      >
        <v-list-tile @click="onGoToHome">
          <v-list-tile-action>
            <v-icon color="text">
              mdi-home
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="view">{{ strings.home }}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="isSuper" @click="onGoToAssign">
          <v-list-tile-action>
            <v-icon color="text">
              mdi-format-list-bulleted-square
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="view">Unassigned</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="isSuper" @click="onGoToRepair">
          <v-list-tile-action>
            <v-icon color="text">
              mdi-wrench
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="view">Repairs</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="settingShowAboutPage"
          @click="onGoToAbout"
        >
          <v-list-tile-action>
            <v-icon color="text">
              mdi-cloud-question
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="view">{{ strings.help }}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="settingShowChangePasswordPage"
          @click="onGoToChangePassword"
        >
          <v-list-tile-action>
            <v-icon color="text">
              mdi-key-change
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="view">{{ strings.changePassword }}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <div v-if="!userToken">
          <v-list-tile @click="onGoToLogin">
            <v-list-tile-action>
              <v-icon color="text">
                mdi-login
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <span class="view">{{ strings.login }}</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
        <div v-else>
          <v-list-tile @click="onGoToLogout">
            <v-list-tile-action>
              <v-icon color="text">
                mdi-logout
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <span class="view">{{ strings.logOut }}</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
      dark
      color="toolbar-custom"
    >
      <v-toolbar-side-icon @click="onSideIconClick">
        <v-icon color="primary">
          mdi-menu
        </v-icon>
      </v-toolbar-side-icon>
      <v-toolbar-title><Brand /> </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <!-- <v-btn icon>
          <v-icon color="text">mdi-search</v-icon>
        </v-btn> -->
        <v-btn icon>
          <v-icon
            large
            @click="onUpdate"
          >
            mdi-cached
          </v-icon>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items>
        <v-btn
          v-if="notificationsCount > 0"
          icon
          class="ml-5"
          @click="goToNotifications"
        >
          <v-icon color="light">
            mdi-bell-ring
          </v-icon>
          <span class="action">
            <h6>{{ notificationsCount }}</h6>
          </span>
        </v-btn>
      </v-toolbar-items>
      <v-btn
        v-if="actionsCount >= 1"
        icon
        class="ml-5"
      >
        <v-progress-circular
          v-if="actionsLoading"
          indeterminate
          class="unset"
        />
        <NoWifiWait
          v-if="!actionsLoading"
          class="v-icon mdi"
        />
        <span
          v-if="!actionsLoading"
          class="action"
        >
          <h6>{{ actionsCount }}</h6>
        </span>
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-container
        fluid
        fill-height
        class="view no-pad"
      >
        <router-view />
      </v-container>
    </v-content>
    <v-dialog
      v-model="errorDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        class="error-dialog"
        dark
      >
        <v-card-text>
          {{ globalError }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            icon
            @click="errorDialog = null"
          >
            {{ strings.ok }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--<v-footer app></v-footer>-->
  </v-app>
</template>

<script>
import Brand from "@/components/Brand";
import NoWifiWait from "@/Icons/NoWifiWait";
import { mapGetters } from "vuex";

export default {
  name: "RootApp",
  components: {
    Brand,
    NoWifiWait
  },
  data() {
    return {
      drawer: null,
      ght: null,
      onLine: navigator.onLine,
      showOnline: false,
      actionsCount: 0,
      notificationsCount: 0,
      numberIcons: [
        "mdi-numeric-0",
        "mdi-numeric-1",
        "mdi-numeric-2",
        "mdi-numeric-3",
        "mdi-numeric-4",
        "mdi-numeric-5",
        "mdi-numeric-6",
        "mdi-numeric-7",
        "mdi-numeric-8",
        "mdi-numeric-9",
        "mdi-numeric-9-plus-box-multiple-outline"
      ]
    };
  },
  computed: {
    ...mapGetters("login", ["userToken", "userId", "technicianId", "selectedAccount", "accounts", "isSuper"]),
    ...mapGetters("actions", {
      actions: "actions",
      actionsLoading: "loading"
    }),
    ...mapGetters("notifications", {
      notifications: "notifications"
    }),
    ...mapGetters("settings", {
      settingShowAboutPage: "showAboutPage",
      settingShowChangePasswordPage: "showChangePasswordPage"
    }),
    ...mapGetters("errors", {
      globalError: "error"
    }),
    ...mapGetters("group", ["groups"]),
    ...mapGetters("page", ["strings"]),
    accountList() {
      return this.accounts.map(l => {
        return {
          name: l.name,
          value: l
        }
      });
    },
    groupList() {
      if(this.selectedAccount) {
        return this.groups.filter(l => l.account == this.selectedAccount.id);
      }
      else {
        return [];
      }
    },
    errorDialog: {
      get() {
        return this.globalError !== null && this.globalError !== undefined;
      },
      set(value) {
        if (!value) this.$store.commit("errors/clearError");
      }
    },
    online: {
      get() {
        return this.$store.getters["app/online"];
      },
      set(value) {
        if (value) {
          this.$store.commit("app/setOnline");
        } else {
          this.$store.commit("app/setOffline");
        }
      }
    }
  },
  watch: {
    onLine(value) {
      this.online = value;
      if (value) {
        this.$toasted.show("Online", {
          icon: "wifi"
        });
        this.$store.dispatch("actions/applyActions");
      } else {
        this.$toasted.show("Offline", {
          icon: "wifi-off"
        });
      }
    },
    actions(value) {
      this.actionsCount = Object.keys(value).length;
    },
    notifications(value) {
      this.notificationsCount = Object.keys(value).length;
    }
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);

    if (navigator.onLine) {
      this.$store.commit("app/setOnline");
    } else {
      this.$store.commit("app/setOffline");
    }
    var language;
    if (window.navigator.languages) {
        language = window.navigator.languages[0];
    } else {
        language = window.navigator.userLanguage || window.navigator.language;
    }
    this.$store.dispatch("page/getStrings", language);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
  methods: {
    async onUpdate() {
      if (this.technicianId == null) {
        // try tecnicianID from cache
        const cachedUser = this.$ls.get("technicianId");
        if (cachedUser != null) {
          this.$store.commit("login/setTechnicianId", cachedUser);
        } else {
          this.$router.push({ name: "login" }).catch(() => {});
        }
      }
      await this.$store.dispatch("group/GetGroupsForTechnician");
      this.$store.dispatch("group/GetAllGroups");
      this.$store.dispatch("group/GetRepairGroups");
      this.$store.dispatch("settings/getSetting");
      this.$router.push("/").catch(() => {});
    },
    updateOnlineStatus(event) {
      const { type } = event;
      this.onLine = type === "online";
    },
    selectNumberIcon(value) {
      if (value <= 0) {
        return this.numberIcons[0];
      } else if (value >= this.numberIcons.length - 1) {
        return this.numberIcons[this.numberIcons.length - 1];
      } else {
        return this.numberIcons[value];
      }
    },
    onSideIconClick() {
      this.drawer = !this.drawer;
    },
    onGoToHome() {
      this.$router.push("/").catch(() => {});
    },
    onGoToAssign() {
      this.$router.push("/assign").catch(() => {});
    },
    onGoToRepair() {
      this.$router.push("/repair").catch(() => {});
    },
    onGoToAbout() {
      this.$router.push("/about");
    },
    onGoToChangePassword() {
      this.$router.push("/changePassword").catch(() => {});
    },
    onGoToLogin() {
      this.$router.push("/login").catch(() => {});
    },
    onGoToLogout() {
      this.$store.dispatch("login/logout").catch(() => {});
      this.$router.push("/login");
    },
    onNavigateToGroup(groupId) {
      this.$store.commit("group/setActiveGroup", groupId);
      this.$store.commit("network/clear");
      this.$router
        .push({ name: "outstanding", params: { id: groupId } })
        .catch(() => {});
    },
    onNavigateToAccount(account) {
      this.$store.commit("login/setSelectedAccount", account);
      this.drawer = false;
      this.$router.push("/").catch(() => {});
    },
    goToNotifications() {
      this.$router.push("/notifications").catch(() => {});
    }
  }
};
</script>

<style lang="less">
.error-dialog {
  background-color: var(--v-secondary-darken1);
  color: white;
}
.v-list__group__header__prepend-icon .v-icon {
  color: var(--v-text-base) !important;
}
.toolbar-custom {
  background-color: white;
}
html {
  overflow-y: auto !important;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: var(--v-background-base);
  color: var(--v-text-base);
}

.view {
  color: var(--v-text-base);
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.text-text {
  color: var(--v-primary-base);
}
.container.fill-height.no-pad {
  padding: 0px;
  margin: 0;
}

.paused {
  background-image: url("/img/icons/pause-word-pattern.svg") !important;
}

.on-site {
  background-image: url("/img/icons/onSite-word-pattern.svg") !important;
}

.awaiting-internet {
  background-image: url("/img/icons/awaiting-internet-word-pattern.svg") !important;
}

.primeweb {
  background-color: #f8f8f8 !important;
}
.primeweb--text {
  color: #005387 !important;
  caret-color: #005387 !important;
}
.primeweb.darken-3 {
  background-color: black !important;
}
.primeweb--text.text--darken-3 {
  color: black !important;
  caret-color: #00243b !important;
}
.primeweb.lighten-2 {
  background-color: #2779aa !important;
  border-color: #2779aa !important;
}
.primeweb--text.text--lighten-2 {
  color: #2779aa !important;
  caret-color: #2779aa !important;
}
.primeweb.lighten-4 {
  background-color: #6ed0f7 !important;
  border-color: #6ed0f7 !important;
}
.primeweb--text.text--lighten-4 {
  color: #6ed0f7 !important;
  caret-color: #6ed0f7 !important;
}

.v-list__group__header--active
  .v-list__group__header__prepend-icon
  .theme--dark.v-icon {
  color: black;
}
.action {
  background: #b71c1c;
  border-radius: 1rem;
  min-width: 1rem;
}

.v-progress-circular.unset {
  position: unset;
}
.container.no-gutter {
  padding: 0 !important;
}

.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
  padding-right: 12px;
  caret-color: black;
}
</style>
